import {Action, State, StateContext, Store} from '@ngxs/store';
import {Injectable, NgZone} from '@angular/core';
import {
  AddReport,
  DeleteReport,
  FetchReports, FetchYears,
} from './reports.actions';
import {ReportsService} from '../services/reports.service';
import {tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {append, patch, removeItem, updateItem, insertItem} from '@ngxs/store/operators';
import {Widget} from '../../core/models';
import {Report} from "../models";
import {HistoryService} from "../../history/services/history.service";
import { formatDate } from "@angular/common";

export interface reportYear {
  year: number,
  default: boolean,
}

export class ReportsStateModel {
  public items: Report[];
  public loading: boolean;
  public dataLoaded: boolean;
  public years: reportYear[];
}


@State<ReportsStateModel>({
  name: 'reports',
  defaults: {
    items: [],
    loading: false,
    dataLoaded: false,
    years: [],
  }
})
@Injectable()
export class ReportsState {

  @Action(FetchReports)
  fetch(ctx: StateContext<ReportsStateModel>, action: FetchReports) {
    const state = ctx.getState();
    ctx.patchState({loading: true});

    return this.reportsService.fetchReports().pipe(
      tap((response: any) => {

        ctx.patchState({
          items: response as Report[],
          loading: false,
          dataLoaded: true
        });
      })
    );
  }

  @Action(FetchYears)
  fetchYears(ctx: StateContext<ReportsStateModel>, action: FetchYears) {
    // const state = ctx.getState();

    return this.reportsService.fetchYears().pipe(
      tap((response: any) => {

        ctx.patchState({
          years: response.years as reportYear[],
        });
      })
    );
  }

  @Action(AddReport)
  addReport(ctx: StateContext<ReportsStateModel>, action: AddReport) {
    return this.reportsService.addReport(action.payload).pipe(
      tap((response: any) => {
        ctx.setState(
          patch({
            items: insertItem(response, 0),
          })
        );

        this.ngZone.run(() => {
          this.snackBar.open(
            'Отчет сформирован',
            null,
            {
              duration: 3000
            });
        });
        const format = 'dd/MM/yyyy';
        const locale = 'en-US';
        const formattedDate = formatDate(response.created_at, format, locale);

          const str = `#${response.id} Тип отчёта: ${response.report_type_loc}, дата формирования: ${formattedDate}, дата обновления базы: ${response.database_ver}, университет: ${response.university_name}`;
          console.log(str);

        this.historyService.addAction({
          'text': `добавил отчёт "${str}"`,
          'model': 'report',
          'operation': 'create',
          'object_id': response.id
        })

      })
    );
  }

  @Action(DeleteReport)
  deleteReport(ctx: StateContext<ReportsStateModel>, action: DeleteReport) {

    const state = ctx.getState();

    return this.reportsService.deleteReport(action.report.id).pipe(
      tap((response) => {

        ctx.setState(
          patch({
            items: removeItem((i: any) => i.id === action.report.id),
          })
        );
        const format = 'dd/MM/yyyy';
        const locale = 'en-US';
        const formattedDate = formatDate(action.report.created_at, format, locale);
          const str = `#${action.report.id} Тип отчёта: ${action.report.report_type_loc}, дата формирования: ${formattedDate}, дата обновления базы: ${action.report.database_ver}, университет: ${action.report.university_name}`;
          console.log(str);

        this.historyService.addAction({
          'text': `удалил отчёт "${str}"`,
          'model': 'report',
          'operation': 'delete',
          'object_id': action.report.id
        })

      })
    );
  }

  constructor(private reportsService: ReportsService,
              private historyService: HistoryService,
              private ngZone: NgZone,
              private snackBar: MatSnackBar,
              private store: Store) {
  }

}
